// A term's parts of term (the Registrar's sessions), as the request form
// offers them. The server sends the list on the term; a term without one
// offers the full semester only. Keep DEFAULT_PART_OF_TERM,
// PART_OF_TERM_MAX_LENGTH and OTHER_PART_OF_TERM in step with server/src/services/partsOfTerm.js.

// The form's code for a part of term typed in as free text
export const OTHER_PART_OF_TERM = 'other';

// The most characters the server keeps of a part of term's name
export const PART_OF_TERM_MAX_LENGTH = 100;

export const DEFAULT_PART_OF_TERM = Object.freeze({
    code: '1',
    name: 'Full Semester Session',
});

const DEFAULT_LIST = Object.freeze([DEFAULT_PART_OF_TERM]);

export const partsOfTermOf = (term) =>
    term?.partsOfTerm?.length ? term.partsOfTerm : DEFAULT_LIST;

// What a new request answers until the faculty member picks another: the
// full semester (code 1) if the term lists it, else its first session
export const defaultPartOfTerm = (parts) =>
    parts.find((p) => p.code === DEFAULT_PART_OF_TERM.code) || parts[0];

// Dates are calendar days, stored at UTC midnight
const formatDay = (value) =>
    new Date(value).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    });

export function partOfTermDates(part) {
    if (!part?.startDate || !part?.endDate) return '';
    return `${formatDay(part.startDate)} to ${formatDay(part.endDate)}`;
}

// The dropdown's text for a session: its name, and its dates when the
// admin gave them
export function partOfTermOptionLabel(part) {
    const dates = partOfTermDates(part);
    return dates ? `${part.name} (${dates})` : part.name;
}
